import React, { useEffect } from "react"
import Layout from "../components/layout"
import SEO from "../components/seo"
import TextBlock from "../components/textBlock"
import Carousel from "../components/carousel"
import Item from "../components/item"
import Tiles from "../components/tiles"
import HeroSVG from "../images/careers/rocket_exploration.svg"
import HeroBG from "../images/careers/bg00.jpg"

import "../components/cv.scss"
import "../components/indeedjobs.scss"

import Birthday from "../images/careers/birthday.svg"
import Flexible from "../images/careers/work-anywhere.svg"
import Outings from "../images/careers/beers.svg"
import Health from "../images/careers/healthcare.svg"
import Games from "../images/careers/gaming.svg"
import Dress from "../images/careers/clothing.svg"
import Pension from "../images/careers/savings_small.svg"
import Wallet from "../images/careers/wallet.svg"

import BgSet1img01 from "../images/careers/bg01.png"
import BgSet1img02 from "../images/careers/bg02.png"
import BgSet1img03 from "../images/careers/bg03.png"

import BgSet2img01 from "../images/careers/bg04.jpg"
import BgSet2img02 from "../images/careers/bg05.jpg"
import BgSet2img03 from "../images/careers/bg06.jpg"

import BgSet3img01 from "../images/careers/bg06.jpg"
import BgSet3img02 from "../images/careers/bg07.jpg"
import BgSet3img03 from "../images/careers/bg08.jpg"
import { Helmet } from "react-helmet"

const carouselData = [
  {
    title: `We’re on a Mission.<br/> <span class="highlight">Are you?</span>`,
    subtitle: "Big clients | startup vibes",
    image: HeroSVG,
    backgroundImage: HeroBG,
  },
]

const itemsData = [
  { name: "Competitive package.", image: Wallet },
  { name: "Flexible working.", image: Flexible },
  { name: "Private healthcare.", image: Health },
  { name: "Pension scheme.", image: Pension },
  { name: "Regular social outings.", image: Outings },
  { name: "Never work your birthday.", image: Birthday },
  { name: "Relaxed dress code.", image: Dress },
  { name: "Games zones.", image: Games },
]

const tilesData1 = [
  {
    backgroundImage: BgSet1img01,
  },
  {
    backgroundImage: BgSet1img02,
  },
  {
    backgroundImage: BgSet1img03,
  },
]

const tilesData2 = [
  {
    backgroundImage: BgSet2img01,
  },
  {
    backgroundImage: BgSet2img02,
  },
  {
    backgroundImage: BgSet2img03,
  },
]

const tilesData3 = [
  {
    backgroundImage: BgSet3img01,
  },
  {
    backgroundImage: BgSet3img02,
  },
  {
    backgroundImage: BgSet3img03,
  },
]

const AgentEfficiency = () => {
  return (
    <Layout>
      <Helmet>
        <script type="application/javascript">{`
          function loadJobs() {
            setTimeout(() => {
              var widget = new RTWidget({
                "companies": [
                  54736
                ],
                "detailsMode": "recruitee",
                "language": "en",
                "departmentsFilter": [],
                "themeVars": {
                  "primary": "#1999e3",
                  "secondary": "#000",
                  "text": "#5c6f78",
                  "textDark": "#37474f",
                  "fontFamily": '"Helvetica Neue", Helvetica, Arial, "Lucida Grande", sans-serif;',
                  "baseFontSize": "16px"
                },
                "flags": {
                  "showLocation": true,
                  "showCountry": true,
                  "showCity": true,
                  "groupByLocation": false,
                  "groupByDepartment": true,
                  "groupByCompany": false
                }
              });
            }, 200);
          }
        `}</script>
        <script
          src="https://d10zminp1cyta8.cloudfront.net/widget.js"
          onLoad="loadJobs()"
          type="text/javascript"
        />
      </Helmet>
      <SEO
        title="Technology & Software Careers at Mission Labs"
        description="We’re hiring! If you care about transforming digital customer experiences as much as we do, we’d like to hear form you. We’re always looking for talented people to join our passionate, hard-working team. results-driven approach. "
        keywords="mission labs careers, circleloop careers, smartagent careers, smartpci, agent amazon connect careers, cloud careers, software development careers, sofware development roles, software development jobs, uk tech companies, technology manchester, manchester digital, software companies, tech startup manchester, tech company lancashire, manchester digital, aws partner, aws careers, tech careers, tech jobs, technology jobs, javascript jobs, digital customer experience, customer experience jobs"
        robots="index, follow"
        revisit_after="1 month"
      />
      <Carousel data={carouselData} />
      <TextBlock
        contrast
        title="<span>Mission /ˈmɪʃ(ə)n/ </span> <br/> Noun: An important assignment given to a person or group of people."
      >
        <p>
          We’re a quirky bunch made up of self-confessed coffee geeks,
          rock-climbers, musicians, runners and gamers. Whether you’re creating
          chatbots for the FTSE 100 or helping a charity get cloud ready - we
          think the best ideas happen when like minded individuals come
          together.
        </p>
      </TextBlock>
      <section className="centre section-padding theme-green section--center">
        <h2>
          Why <span className="highlight">join us?</span>
        </h2>
        <hr />
        <div className="items items--center items--four-cols">
          {itemsData.map(({ name, image }) => (
            <Item name={name} image={image} key={name} />
          ))}
        </div>
      </section>

      <TextBlock
        noUnderline
        contrast
        title="<span>“Mission Labs is a great place to work. Not only do I get to work with some of the best and brightest brands around the world, I really feel part of a close-knit team who I learn from every single day.”</span>"
        contrast_color="blue"
      >
        <p>
          <b>Matt</b>
          <br />
          <span>Product Developer</span>
        </p>
      </TextBlock>

      <section className="section section-padding section--center">
        <div className="centre">
          <h2>
            Our <span className="highlight">coordinates</span>
          </h2>

          <hr />
          <p>
            We feel it’s important to stay true to our roots, but it’s also
            important to be where the action is.
            <br /> That’s why we have several working locations to offer
            flexible and varied environments for our teams.
          </p>
        </div>
      </section>

      <Tiles data={tilesData1} />

      <section className="section section-padding section--center">
        <div className="centre">
          <h2>
            Arbeta, <span className="highlight">Manchester.</span>
          </h2>
          <p>
            <span className="highlight"> Close to the hustle and bustle</span>
          </p>
          <p>
            There’s no doubt that Manchester is home to some amazing talent. As
            the largest tech hub
            <br /> outside of London, we wanted to build an environment where
            innovation and creativity could
            <br /> come together to help us bring the future forward faster.
          </p>
          <hr />
        </div>
      </section>
      <Tiles data={tilesData2} />

      <section className="section section-padding section--center">
        <div className="centre">
          <h2>
            The Old Milk Depot & <br />
            <span className="highlight">Hardmans Mill, Lancashire.</span>
          </h2>
          <p>
            <span className="highlight"> Close to our roots</span>
          </p>
          <p>
            As we develop our presence in new locations, it is still important
            for us to nurture local tech talent <br /> and stay true to our
            roots. Our two office spaces in Rawtenstall provide ease of access
            from <br />
            major motorways as well as iconic Northern scenery.
          </p>
          <hr />
        </div>
      </section>
      <Tiles data={tilesData3} />

      <section className="section section-padding section--center">
        <div className="centre">
          <h2>
            Remote <span className="highlight">working.</span>
          </h2>
          <p>
            <span className="highlight"> Keeping things flexible</span>
          </p>
          <p>
            Now more than ever it’s important to have flexibility in where you
            work. We have a pragmatic <br /> approach to working remotely; we
            want you to bring the best version of yourself to work,
            <br /> wherever that is.
          </p>
          <hr />
        </div>
      </section>

      <section className="inverse section--center section-padding">
        <div className="centre">
          <h2>
            Current <span>openings.</span>
          </h2>
          <hr />
          <div id="recruitee-careers"></div>
        </div>
      </section>

      <section className="section section-padding section--center">
        <div className="centre">
          <h2>
            Send us <span>your cv.</span>
          </h2>
          <hr />
          <p className="lead">
            We’re always interested in hearing from talented people. Whether you
            specialise in software development, app development, sales, tech
            support, testing, marketing or design we’d love to hear from you.
            Email us your CV to{" "}
            <a
              className="highlight bolder"
              href="mailto:jobs@missionlabs.co.uk"
            >
              jobs@missionlabs.co.uk
            </a>
          </p>
        </div>
      </section>
    </Layout>
  )
}

export default AgentEfficiency
